import { useState, useEffect, useCallback } from "react";

const useTimer = (seconds) => {
    const delay = seconds * 1000;
    const [state, setState] = useState(() => ({
        time: 0,
        countdown: 0,
        isOn: false,
        isExpired: false
    }));
    const [startTime, setStartTime] = useState(() => 0);
    const getTime = useCallback(() => {
        return Date.now() - startTime;
    }, [startTime]);

    const stopTimer = () => {
        if (state.isOn) {
            setState((state) => ({ ...state, isOn: false }));
        }
    };

    const resetTimer = () => {
        setState((state) => ({ ...state, time: 0, isOn: false, isExpired: false }));
    };
    useEffect(() => {
        let interval = null;

        if (state.isOn) {
            interval = setInterval(() => {
                const t = getTime();
                setState({
                    isOn: t < delay,
                    countdown: state.countdown - 1,
                    time: t,
                    isExpired: t >= delay
                });
            }, 1000);
        } else if (!state.isOn && state.time !== 0) {
            clearInterval(interval);
        }
        return () => {
            clearInterval(interval);
        };
    }, [state.isOn, state.time, state.countdown, getTime,delay]);

    const startTimer = () => {
        if (!state.isOn) {
            setStartTime(Date.now() );
            setState({
                time: 0,
                countdown: seconds,
                isOn: true,
                isExpired: false
            });
        }
    };

    return [state.isOn, state.countdown, state.isExpired, startTimer, stopTimer, resetTimer];
}

export default useTimer;